import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IAPIDonationGridModel } from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";

 
 
export class DonationGridModel {
    id: string;
    name: string;
    createdDate: Date;
    success: boolean;
    donationPaidTo: string;
    isRefund: boolean;
    amount: number;
    contact?: ContactReferenceModel;
    constructor(data?: Partial<DonationGridModel>) {
        this.name = data?.name || '';
        this.createdDate = data?.createdDate || new Date();
        this.id = data?.id || '';
        this.success = data?.success || false;
        this.donationPaidTo = data?.donationPaidTo || '';
        this.isRefund = data?.isRefund || false;
        this.amount = data?.amount || 0;
        this.contact = data?.contact && new ContactReferenceModel(data.contact);
    }

    static deserialize(data: IAPIDonationGridModel): DonationGridModel {
        return new DonationGridModel({
            name: data.donationName,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
            id: data.donationId,
            donationPaidTo: data.donationPaidTo,
            success: data.success,
            isRefund: data.isRefund,
            amount: data.amount,
            contact: data.contact && ContactReferenceModel.deserializeAPIModel(data.contact),
        });
    }
}
